import { PolicyComponentTypes } from "@enums/policy-component-types";

export const POLICY_COMPONENT_TYPE_OPTIONS = [
    {
        label: "Match All",
        value: PolicyComponentTypes.AND
    },
    {
        label: "Match Any",
        value: PolicyComponentTypes.OR
    }
];